import { jsx } from 'react/jsx-runtime';
import React, { useState, useCallback, useEffect } from 'react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var defaultUserInfo = {
    avatar: '',
    lives: [],
    loggedIn: false,
    seasonCode: '',
    user: {
        userId: null,
        firstName: '',
        lastName: '',
        role: '',
        shippingCountry: '',
        shippingState: '',
        shippingZipCode: '',
        shippingCity: '',
        subscriptionEndDate: 0,
        subscriptionStartDate: 0,
        subscriptionState: '',
        subscriptionType: '',
        email: '',
        planCode: '',
    },
};
var defaultContext = {
    userInfo: defaultUserInfo,
    clearStorage: function () { },
    invalidateUserCache: function () { },
};

function request(_a) {
    var path = _a.path, _b = _a.method, method = _b === void 0 ? 'GET' : _b, body = _a.body, _c = _a.json, json = _c === void 0 ? true : _c, _d = _a.contentType, contentType = _d === void 0 ? 'application/json; charset=utf-8' : _d;
    return __awaiter(this, void 0, void 0, function () {
        var defaultHeaders, response, status;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    defaultHeaders = {
                        'FFF-Auth': 'V1.1',
                        'Content-Type': contentType,
                    };
                    return [4, fetch(path, {
                            credentials: 'include',
                            headers: __assign({}, defaultHeaders),
                            body: method !== 'GET' ? body : null,
                            mode: 'cors',
                            method: method,
                        })];
                case 1:
                    response = _e.sent();
                    status = response.status;
                    switch (status) {
                        case 200:
                            return [2, json ? response.json() : response.text()];
                        case 400:
                            return [2, Promise.reject(new Error('Bad request'))];
                        case 401:
                            return [2, Promise.reject(new Error('Unauthorized'))];
                        case 403:
                            return [2, Promise.reject(new Error('Forbidden'))];
                        case 408:
                            return [2, Promise.reject(new Error('Timeout'))];
                        case 500:
                            return [2, Promise.reject(new Error('API internal error'))];
                        case 502:
                            return [2, Promise.reject(new Error('Proxy error'))];
                        case 503:
                            return [2, Promise.reject(new Error('Service unavailable'))];
                        case 504:
                            return [2, Promise.reject(new Error('Timeout'))];
                        default:
                            return [2, Promise.reject(new Error("Unhandled HTTP code: ".concat(status)))];
                    }
            }
        });
    });
}

function isBrowser() {
    return ![typeof window, typeof document].includes('undefined');
}

var removeFromStorage = function (_a) {
    var key = _a.key;
    if (isBrowser()) {
        sessionStorage.removeItem("FFF_".concat(key));
    }
};
var getFromStorage = function (_a) {
    var key = _a.key, _b = _a.defaultItem, defaultItem = _b === void 0 ? null : _b;
    if (!isBrowser())
        return defaultItem;
    var stgItem = sessionStorage.getItem("FFF_".concat(key));
    if (!stgItem)
        return defaultItem;
    try {
        var _c = JSON.parse(stgItem), createAt = _c.createAt, durationInMs = _c.durationInMs, data = _c.data;
        var currentTime = Date.now();
        var isExpired = durationInMs !== 0 && createAt + durationInMs < currentTime;
        if (!durationInMs || (createAt && durationInMs && data && !isExpired)) {
            return data;
        }
        removeFromStorage({ key: key });
    }
    catch (error) {
        console.error('Error when deserializing JSON navigation');
    }
    return defaultItem;
};
var setToStorage = function (_a) {
    var key = _a.key, value = _a.value, _b = _a.durationInMs, durationInMs = _b === void 0 ? 0 : _b;
    var itemWithExpirationTime = {
        createAt: Date.now(),
        durationInMs: durationInMs,
        data: value,
    };
    var json = JSON.stringify(itemWithExpirationTime);
    if (isBrowser()) {
        sessionStorage.setItem("FFF_".concat(key), json);
    }
};
var clearStorage = function () {
    if (isBrowser()) {
        sessionStorage.clear();
    }
};
var clearFFFStorage = function () {
    if (isBrowser()) {
        Object.keys(sessionStorage).forEach(function (key) {
            if (key.startsWith('FFF_')) {
                sessionStorage.removeItem(key);
            }
        });
    }
};
var SESSION_STORAGE_KEY = {
    userInfo: 'user-info-app',
};
var SESSION_STORAGE_EVENT = 'sessionStorage';

var storage = /*#__PURE__*/Object.freeze({
  __proto__: null,
  removeFromStorage: removeFromStorage,
  getFromStorage: getFromStorage,
  setToStorage: setToStorage,
  clearStorage: clearStorage,
  clearFFFStorage: clearFFFStorage,
  SESSION_STORAGE_KEY: SESSION_STORAGE_KEY,
  SESSION_STORAGE_EVENT: SESSION_STORAGE_EVENT
});

var hostname = function () { return (isBrowser() ? window.location.hostname : 'fabfitfun.com'); };

var EnvironmentNames;
(function (EnvironmentNames) {
    EnvironmentNames["PROD"] = "prod";
    EnvironmentNames["QA"] = "qa";
    EnvironmentNames["DEV"] = "dev";
    EnvironmentNames["LOCAL"] = "local";
})(EnvironmentNames || (EnvironmentNames = {}));
var EnvironmentNames$1 = EnvironmentNames;

var getEnvUsingWindowLocation = function () {
    if (hostname().includes('fabfitfun'))
        return EnvironmentNames$1.PROD;
    if (hostname().includes('fff-qa'))
        return EnvironmentNames$1.QA;
    return EnvironmentNames$1.DEV;
};

var envUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getEnvUsingWindowLocation: getEnvUsingWindowLocation
});

var getEnv = function (getEnvProps) {
    var enF = (getEnvProps === null || getEnvProps === void 0 ? void 0 : getEnvProps.env) || getEnvUsingWindowLocation();
    if (enF === EnvironmentNames$1.LOCAL) {
        return __assign(__assign({}, getEnv({ env: EnvironmentNames$1.DEV })), { name: EnvironmentNames$1.LOCAL });
    }
    if (enF === EnvironmentNames$1.PROD) {
        return {
            name: EnvironmentNames$1.PROD,
            REACT_APP_NAVIGATOR_URL: 'https://universal-navigation-api.fabfitfun.com',
            REACT_APP_USER_INFO_URL: 'https://universal-navigation-api.fabfitfun.com/menu/user-data',
            REACT_APP_BASE_URL: 'https://fabfitfun.com',
            REACT_APP_TIMER_URL: 'https://universal-navigation-api.fabfitfun.com/timer',
            REACT_APP_NEW_MEMBER_CAMPAIGN_URL: 'https://customize-api.fabfitfun.com/customize/new-members/self/campaign-state',
            REACT_APP_NEW_MEMBER_API_URL: 'https://new-member-api.fabfitfun.com',
            REACT_APP_BANNER_URL: 'https://homepage-api.fabfitfun.com/megaphone-banners/current',
            REACT_APP_ADDONS_URL: 'https://fabfitfun.com/add-ons',
            REACT_APP_EDIT_URL: 'https://fabfitfun.com/edit',
        };
    }
    return {
        name: enF,
        REACT_APP_NAVIGATOR_URL: "https://universal-navigation-api.fff-".concat(enF, ".com"),
        REACT_APP_USER_INFO_URL: "https://universal-navigation-api.fff-".concat(enF, ".com/menu/user-data"),
        REACT_APP_BASE_URL: "https://fff-".concat(enF, ".com"),
        REACT_APP_TIMER_URL: "https://universal-navigation-api.fff-".concat(enF, ".com/timer"),
        REACT_APP_NEW_MEMBER_CAMPAIGN_URL: "https://customize-api.fff-".concat(enF, ".com/customize/new-members/self/campaign-state"),
        REACT_APP_NEW_MEMBER_API_URL: "https://new-member-api.fff-".concat(enF, ".com"),
        REACT_APP_BANNER_URL: "https://homepage-api.fff-".concat(enF, ".com/megaphone-banners/current"),
        REACT_APP_ADDONS_URL: "https://fff-".concat(enF, ".com/add-ons"),
        REACT_APP_EDIT_URL: "https://fff-".concat(enF, ".com/edit"),
    };
};

var userInfoKey = 'user-info-app';

var durationUserInfo = 5 * 60 * 1000;

var publicPaths = ['login'];
var currentPath = isBrowser() ? window.location.href : '';
var isPublicPage = !!publicPaths.find(function (publicPath) { return currentPath.includes(publicPath); });

var fetchUserInfo = function (_a) {
    var env = _a.env;
    return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, request({ path: env.REACT_APP_USER_INFO_URL })];
                case 1:
                    response = _b.sent();
                    return [2, response];
            }
        });
    });
};
var invalidateUserCache = function () { return removeFromStorage({ key: userInfoKey }); };
var getUserFromStorage = function () { return getFromStorage({ key: userInfoKey, defaultItem: defaultUserInfo }); };
var getUserInfo = function (forceRefresh) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var userFromSTG, requestUserInfo, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isPublicPage)
                        return [2, Promise.resolve(defaultUserInfo)];
                    userFromSTG = getFromStorage({ key: userInfoKey });
                    if (!forceRefresh && userFromSTG) {
                        return [2, userFromSTG];
                    }
                    removeFromStorage({ key: userInfoKey });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, fetchUserInfo({ env: getEnv() })];
                case 2:
                    requestUserInfo = _a.sent();
                    if (requestUserInfo) {
                        setToStorage({
                            key: userInfoKey,
                            value: requestUserInfo,
                            durationInMs: durationUserInfo,
                        });
                        return [2, requestUserInfo];
                    }
                    return [3, 4];
                case 3:
                    err_1 = _a.sent();
                    if (err_1.message === 'Unauthorized' || err_1.message === 'Forbidden') {
                        removeFromStorage({ key: userInfoKey });
                    }
                    else {
                        console.log(err_1, err_1.message);
                    }
                    return [3, 4];
                case 4: return [2, Promise.resolve(defaultUserInfo)];
            }
        });
    });
};

var isEqualObject = function (object1, object2) {
    if (!object1 && !object2)
        return true;
    if ((!object1 && object2) || (object1 && !object2))
        return false;
    var keys1 = Object.keys(object1);
    var keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length)
        return false;
    for (var _i = 0, keys1_1 = keys1; _i < keys1_1.length; _i++) {
        var key = keys1_1[_i];
        var val1 = object1[key];
        var val2 = object2[key];
        var areObjects = isObject(val1) && isObject(val2);
        if ((areObjects && !isEqualObject(val1, val2)) || (!areObjects && val1 !== val2))
            return false;
    }
    return true;
};
var isObject = function (object) { return object != null && typeof object === 'object'; };

var compare = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isEqualObject: isEqualObject,
  isObject: isObject
});

var UserContext = React.createContext(defaultContext);
var UserProvider = function (userProviderProps) {
    var children = (userProviderProps || { children: null }).children;
    var _a = useState(getUserFromStorage()), userInfo = _a[0], setUserInfo = _a[1];
    var _b = useState(false), contextReady = _b[0], setContextReady = _b[1];
    var handleSetUserInfo = useCallback(function (newUserInfo) {
        if (!isEqualObject(newUserInfo, userInfo)) {
            setUserInfo(newUserInfo);
        }
    }, []);
    useEffect(function () {
        var handleStorage = function () {
            var sessionStorageData = getFromStorage({ key: SESSION_STORAGE_KEY.userInfo });
            if (sessionStorageData)
                handleSetUserInfo(sessionStorageData);
        };
        window.addEventListener(SESSION_STORAGE_EVENT, handleStorage);
        return function () { return window.removeEventListener(SESSION_STORAGE_EVENT, handleStorage); };
    }, []);
    useEffect(function () {
        getUserInfo()
            .then(function (newUserinfo) {
            handleSetUserInfo(newUserinfo);
            setContextReady(true);
        })
            .catch(function (err) {
            console.log(err);
            setContextReady(true);
        });
    }, [handleSetUserInfo]);
    var displayChildren = contextReady && children;
    return (jsx(UserContext.Provider, __assign({ value: { userInfo: userInfo, clearStorage: clearFFFStorage, invalidateUserCache: invalidateUserCache } }, { children: displayChildren && children })));
};
function useUserContext() {
    var context = React.useContext(UserContext);
    if (!context) {
        throw new Error('You must use the User Provider in order to consume this context.');
    }
    return context;
}

var scriptExists = function (srcPath) {
    var scripts = document.getElementsByTagName('script');
    var i = scripts.length;
    var flag = false;
    while (i--) {
        if (scripts[i].src === srcPath) {
            flag = true;
            break;
        }
    }
    return flag;
};
var scriptExistsById = function (scriptId) {
    var script = document.getElementById(scriptId);
    if (script)
        return script.id === scriptId;
    return false;
};

var scriptExists$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  scriptExists: scriptExists,
  scriptExistsById: scriptExistsById
});

var getParamFromUrl = function (param) {
    if (!isBrowser())
        return '';
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var paramValue = urlParams.get(param);
    return paramValue || '';
};

var calculateExpirationDate = function (expireDate) {
    var expires = "expires=".concat(new Date(expireDate !== null && expireDate !== void 0 ? expireDate : '').toUTCString());
    return expires;
};
var setCookie = function (_a) {
    var key = _a.key, value = _a.value, expireDate = _a.expireDate, path = _a.path, maxAge = _a.maxAge;
    var encodeValue = encodeURIComponent(value);
    var expires = calculateExpirationDate(expireDate);
    var maxAgeValue = "max-age=".concat(60 * 60 * 24 * maxAge);
    document.cookie = "".concat(key, "=").concat(encodeValue, "; ").concat(expireDate ? "".concat(expires, ";") : "".concat(maxAgeValue, ";"), " path=").concat(path);
    return getCookie(key) === encodeValue;
};
var getCookie = function (key) {
    var cookieName = "".concat(key, "=");
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    var foundCookie = cookieArray.find(function (cookie) {
        return cookie.trim().startsWith(cookieName);
    });
    if (foundCookie) {
        return foundCookie.substring(cookieName.length);
    }
    return null;
};
var deleteCookie = function (key) {
    if (key) {
        document.cookie = "".concat(key, "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;");
        return true;
    }
    return false;
};

var cookies = /*#__PURE__*/Object.freeze({
  __proto__: null,
  calculateExpirationDate: calculateExpirationDate,
  setCookie: setCookie,
  getCookie: getCookie,
  deleteCookie: deleteCookie
});

var SUBSCRIPTION_PRICE_INCREASES = { seasonal: 69.99, annual: 219.99 };
var PRICE_INCREASE_DATE = '4/11/24';

var insertZero = function (time, threshold) {
    if (threshold === void 0) { threshold = 10; }
    if (time < threshold) {
        return "0".concat(time);
    }
    return "".concat(time);
};
var getSeconds = function (date) {
    return Math.round(new Date(date).getTime() / 1000 - new Date().getTime() / 1000);
};
var getTimeLeft = function (startDate) {
    var secs = getSeconds(startDate);
    if (secs <= 0) {
        return {
            days: '00',
            hours: '00',
            minutes: '00',
            seconds: '00',
            timeUp: true,
            timerSet: true,
        };
    }
    var days = insertZero(Math.floor(secs / (3600 * 24)));
    var hours = insertZero(Math.floor((secs % (3600 * 24)) / 3600));
    var minutes = insertZero(Math.floor((secs % 3600) / 60));
    var seconds = insertZero(Math.floor((secs % 3600) % 60));
    return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        timeUp: false,
        timerSet: true,
    };
};
function useTimer(startDate, startingMinutes) {
    if (startingMinutes === void 0) { startingMinutes = '05'; }
    var _a = useState({
        days: '00',
        hours: '00',
        minutes: startingMinutes,
        seconds: '00',
        timeUp: false,
        timerSet: false,
    }), timer = _a[0], setTimer = _a[1];
    useEffect(function () {
        if (!startDate) {
            return;
        }
        var intervalId = setInterval(function () {
            var counterTimer = getTimeLeft(startDate);
            setTimer(counterTimer);
            if (timer.timeUp) {
                clearInterval(intervalId);
            }
        }, 1000);
        return function () {
            clearInterval(intervalId);
        };
    }, [startDate]);
    return timer;
}

var Timer = /*#__PURE__*/Object.freeze({
  __proto__: null,
  insertZero: insertZero,
  getSeconds: getSeconds,
  getTimeLeft: getTimeLeft,
  useTimer: useTimer
});

export { compare as Compare, cookies as Cookies, envUtils as EnvUtils, storage as FFFStorage, PRICE_INCREASE_DATE, SUBSCRIPTION_PRICE_INCREASES, scriptExists$1 as ScriptsExists, Timer, UserProvider, getParamFromUrl, getUserInfo, useUserContext };
